<template>
  <div class="width98 margin-auto backwhite pad-bot40">
    <!-- 检索 -->
    <div class="width98 margin-auto pad-top20">
      <p class="Patent-abstract pad-left10">发起成果采购信息</p>
      <el-form ref="form" :model="form" class="pad-top10 flex-aroundwrap">
        <el-form-item label="成果名称" class="width32" prop="tech_keyword">
          <el-input
            placeholder="请输入成果名称"
            v-model="form.title"
            class="width100"
          ></el-input>
        </el-form-item>
        <el-form-item label="成果分类" class="width32" prop="well_known_used">
          <el-select
            v-model="form.cate_id"
            placeholder="请选择成果分类"
            class="width100"
            :filterable="true"
          >
            <el-option label="---  请选择  ---" value=""></el-option>
            <el-option
              v-for="item in pagecate"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交易截止时间" class="width32" prop="start_at">
          <el-date-picker
            class="inputDeep"
            v-model="form.end_date"
            type="date"
            placeholder="请选择出售截止时间"
            value-format="yyyy-MM-dd"
            :editable="false"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="采购主体" class="width32" prop="upsteam">
          <el-input
            placeholder="请输入采购主体"
            v-model="form.author"
            class="width100"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" class="width32" prop="downsteam">
          <el-input
            placeholder="请输入联系电话"
            v-model="form.phone"
            class="width100"
          ></el-input>
        </el-form-item>
        <el-form-item label="采购价格" class="width32" prop="tech_keyword">
          <el-input
            placeholder="请输入采购价格"
            v-model="form.price"
            class="width100"
          ></el-input>
        </el-form-item>
        <el-form-item label="当前状态" class="width32">
          <el-select
            v-model="form.status"
            placeholder="请选择当前状态"
            class="width100"
            :filterable="true"
          >
            <el-option label="---  请选择  ---" value=""></el-option>
            <el-option
              v-for="item in pagestatus"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="转让方式" class="width32" prop="well_known_used">
          <el-select
            v-model="form.transfer_way"
            placeholder="请选择转让方式"
            class="width100"
            :filterable="true"
          >
            <el-option label="---  请选择  ---" value=""></el-option>
            <el-option
              v-for="item in ferway"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="行业" class="width32" prop="well_known_used">
          <el-select
            v-model="form.industry"
            placeholder="请选择行业"
            class="width100"
            :filterable="true"
          >
            <el-option label="---  请选择  ---" value=""></el-option>
            <el-option
              v-for="item in industry"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="成果封面" class="width98">
          <el-upload
            class="avatar-uploader"
            :action="Apisrc"
            name="images"
            :show-file-list="false"
            :on-success="handleAvatarSuccesshead"
            :on-error="handleerrorhead"
            :data="userhead"
            :headers="head"
            style="margin-top: 40px"
          >
            <img v-if="form.pictureurl" :src="form.pictureurl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

        <el-form-item label="" class="width98">
          <p class="textalign-left dimensional f14 margin-bot10">
            <span>技术成熟度说明</span>
          </p>
          <el-input
            type="textarea"
            :rows="5"
            placeholder="请输入内容"
            v-model="form.maturity"
          ></el-input>
        </el-form-item>
        <el-form-item label="" class="width98">
          <p class="textalign-left dimensional f14 margin-bot10">
            <span>详细说明</span>
          </p>
          <wangEditor
            v-model="form.remark"
            :isClear="isClear"
            class="textalign-left"
          ></wangEditor>
        </el-form-item>
      </el-form>
      <div class="textalign-right margin-right20 margin-top20">
        <el-button @click="dialogVisiblefalse()">取 消</el-button>
        <el-button type="primary" @click="toproductmanagement()">
          保存
        </el-button>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { entachievementsindex } from "@/api/Center/Center.api";
import {
  productcate,
  productpurchasesave,
  entproductgoodtransferway,
  entproductgoodindustry,
} from "@/api/business/business.api";
import wangEditor from "@/components/wangEditor";
export default {
  data() {
    return {
      autosize: {
        minRows: 3,
        maxRows: 1000,
      },
      errormessage: "",
      dialogVisiblenull: false,
      page: [],
      pagecate: [],
      ferway: [],
      industry: [],
      imageUrl: "",
      form: {
        title: "",
        phone: "",
        end_date: "",
        author: "",
        cate_id: "",
        price: "",
        // achievements_id: "",
        // image: "http://dummyimage.com/400x400",
        remark: "",
        picture: "",
        pictureurl: "",
        status: "",
        maturity: "",
        industry: "",
        transfer_way: "",
      },
      pagestatus: [
        { name: "进行中", id: 1 },
        { name: "已关闭", id: 2 },
      ],
      userhead: {
        images: "",
      },

      picturehead: "",
      mentSuccess: true,
      mousechanges: "",
      Apisrc: "",
      Apisrcs: "",
      head: {
        token: window.sessionStorage.getItem("token"),
      },

      filebox: [],
      files: [],
      isClear: false, //设置为true的时候，这个可以用this.wangEditorDetail=''来替代
      wangEditorDetail: "",
    };
  },

  components: { wangEditor },
  methods: {
    // 上传附件
    handleAvatarSuccesshead(response, res, file) {
      this.form.picture = res.name;

      if (response.msg == "上传文件后缀不允许") {
        this.dialogVisiblenull = true;
        this.errormessage = response.msg;
      } else {
        if (response.data.url.indexOf("http") == -1) {
          this.form.pictureurl = this.picturehead + response.data.url;
        } else {
          this.form.pictureurl = response.data.url;
        }
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success",
        });
      }
    },
    handleerrorhead(error, file, fileList) {
      let myError = error.toString(); //转字符串
      myError = myError.replace("Error: ", ""); // 去掉前面的" Error: "
      myError = JSON.parse(myError); //转对象
      this.$loadings.hide(); // 隐藏loading
      this.dialogVisiblenull = true;
      this.errormessage = myError.msg;
    },
    toproductmanagement() {
      productpurchasesave({
        title: this.form.title,
        phone: this.form.phone,
        end_date: this.form.end_date,
        author: this.form.author,
        cate_id: this.form.cate_id,
        price: this.form.price,
        // achievements_id: this.form.achievements_id,
        image: this.form.pictureurl,
        remark: this.form.remark,
        status: this.form.status,
        maturity: this.form.maturity,
        industry_id: this.form.industry,
        transfer_way: this.form.transfer_way,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "添加成功",
            type: "success",
          });
          this.$router.push({
            path: "/Results-trading/Achievement-introduction",
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    dialogVisiblefalse() {
      this.$router.push({
        path: "/Results-trading/Achievement-introduction",
      });
    },
  },
  created() {
    this.Apisrc = window.g.ApiUrl + "/oss_form";
    this.picturehead = window.g.Apisrc;
    entachievementsindex({
      page: this.thisNum,
    }).then((res) => {
      if (res.data.code == 200) {
        this.page = res.data.data.data;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
    productcate({
      page: this.thisNum,
    }).then((res) => {
      if (res.data.code == 200) {
        this.pagecate = res.data.data;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
    // 转让方式
    entproductgoodtransferway({
      page: this.thisNum,
    }).then((res) => {
      if (res.data.code == 200) {
        this.ferway = res.data.data;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
    // 行业
    entproductgoodindustry({
      page: this.thisNum,
    }).then((res) => {
      if (res.data.code == 200) {
        this.industry = res.data.data;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
<style scoped>
.Patent-abstract {
  border-left: 4px solid #52c5cb;
  font-weight: 600;
  height: 20px;
  line-height: 20px;
}
.dimensional {
  padding: 20px 0 0 10px;
}
.picturecont {
  width: 100%;
  height: 100%;
  background-color: rgb(85 0 0 / 46%);
  position: absolute;
  text-align: center;
  /* top: 50%; */
  color: white;
  /* text-align: center; */
  z-index: 2;
}
.pictureimg {
  width: 100%;
  height: 110px;
}
.filebox {
  width: 100%;
  height: 110px;
  margin: 0 0 50px 0;
  border: 1px solid #efefef;
  position: relative;
}
.picspan {
  position: relative;
  top: 40%;
  z-index: 3;
}
.uploaddragger >>> .el-upload {
  width: 100%;
}
.uploaddragger >>> .el-upload-dragger {
  width: 100%;
  margin: auto;
}
.avatar-uploader .el-upload {
  border: 1px dashed #6e6d6d;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.uploaddragger >>> .el-upload-dragger:hover {
  border-color: #52c5cb;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 110px;
  height: 110px;
  line-height: 110px;
  /* text-align: center; */
  border: 1px dashed #e5e5e5;
}
.avatar {
  width: 110px;
  height: 110px;
  display: block;
}
.el-form-item {
  margin: 10px 0;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>